import { useContext } from 'react';
import { LOCALSTORAGE_THEME_KEY, Theme, ThemeContext } from './theme-context';

interface UseThemeResult {
  theme: Theme;
  toggleTheme: (themeKey: Theme) => void;
}

export const useTheme = (): UseThemeResult => {
  const { theme, setTheme } = useContext(ThemeContext);
  const toggleTheme = (themeKey: Theme) => {
    let newTheme: Theme;
    switch (themeKey) {
      case 'blueLight':
      default:
        newTheme = 'blueLight';
        break;
    }
    setTheme(newTheme);
    localStorage.setItem(LOCALSTORAGE_THEME_KEY, newTheme);
  };

  return { theme, toggleTheme };
};
